module.exports = __webpack_public_path__ + "static/media/pending.c3cb0fc4.png";